



























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import UpdateAccountGeneralProductSettingsRequest from '@/models/Accounts/Shared/UpdateAccountGeneralProductSettingsRequest';
import ProductIssueType from '@/models/Products/ProductIssues/ProductIssueType';

@Component({ name: 'ProductDetailsEditDialog' })
export default class extends SaascadaVueDialog {

    ProductIssueType = ProductIssueType;

    request: UpdateAccountGeneralProductSettingsRequest = new UpdateAccountGeneralProductSettingsRequest(null, null, null);
    productIssueSelectionType = ProductIssueType.UseCurrentIssue;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.productIssueSelectionType = ProductIssueType.UseCurrentIssue;
            this.request = new UpdateAccountGeneralProductSettingsRequest(DepositAccountSettingsModule.productId, DepositAccountSettingsModule.productIssueId, new Date());
            DepositAccountModule.getProductOptionsForDepositAccount();
        }
    }

    @Watch('request.productId')
    async onRequestProductIdChanged(productID: string) {
        this.request.productIssueId = null;
        DepositAccountModule.getProductIssueOptionsForDepositAccount(productID);
    }

    get productOptions() {
        return DepositAccountModule.productOptions;
    }

    get productIssueOptions() {
        return DepositAccountModule.productIssueOptions;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            if (this.request.productIssueId === null || this.request.productIssueId === '') {
                this.request.productIssueId = undefined;
            }

            await DepositAccountSettingsModule.editGeneralProductSettings(this.request);
            await DepositAccountSettingsModule.getAccount(DepositAccountSettingsModule.accountId);
            await DepositAccountSettingsModule.getProductIssue();
            await DepositAccountModule.getDepositAccount(DepositAccountModule.depositAccount.id);
        }
    }

}
